import '@/styles/main.css';
import "@/styles/boxModel.css";
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@cttq/ui-components-plus-pc/lib/tq-theme/default.css'
import bussinessComponents from '@cttq/ui-components-plus-pc/index.js'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue';
import router from './router';
import { configs } from '@/apis/index'
import { useConfigStore } from "@/stores/index.ts";
import { ElMessage } from 'element-plus'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate' // 新增导入

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate) // 添加持久化插件

// 先注册pinia，然后再使用store
app.use(pinia);

const store = useConfigStore();
configs().then(res => {
    if (res && res?.msgCode === "100") {
        store.setConfigData(res?.responseData);
    } else {
        // TODO: 错误处理
        ElMessage({
            showClose: true,
            message: res?.message,
            type: 'warning',
        })
    }
}).catch(error => {
    console.error('配置加载失败:', error);
});

app.use(router);
app.use(ElementPlus, {
  locale: zhCn
})
app.use(bussinessComponents)
app.mount('#app');